import { brands } from '../api/brands';

const URL_CAR = process.env.REACT_APP_URL_QUOTE_GALENO;

export const getBrands = () => {
  // const res = await fetch(`${URL_CAR}/marcas`, {
  //   method: 'GET',
  //   headers: {
  //     authorization: `Bearer ${localStorage.getItem('token')}`,
  //     'content-type': 'application/json'
  //   }
  // });
  // const brands = await res.json();
  
  return brands;
};

export const getModels = async (brandID) => {
  const res = await fetch(`${URL_CAR}/modelos/${brandID}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
      'content-type': 'application/json'
    }
  });
  const models = await res.json();

  return models;
};

export const getYears = async (brandID, model) => {
  const res = await fetch(`${URL_CAR}/anios/${brandID}/${model}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
      'content-type': 'application/json'
    }
  });
  const years = await res.json();

  return years;
};

export const getVersions = async (brandID, model, year) => {
  const res = await fetch(`${URL_CAR}/submodelos/${brandID}/${model}/${year}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
      'content-type': 'application/json'
    }
  });
  const versions = await res.json();

  return versions;
};
